import React from 'react'
import { Field as FormikField } from 'formik'
import styled from 'styled-components'
import Label from '../../../../Label'
import RemoveCustom from './RemoveCustom'
import name from './lib/name'

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Field = styled(FormikField)`
  height: 34px;
  border-bottom: ${props => props.theme.borders.grey6};
  padding: 0 10px;
  font-size: 14px;
`

export default ({ baseName, custom, editable, arrayHelpers, ...rest }) => {
  if (editable) {
    return (
      <Field
        name={`${baseName}.label`}
        onFocus={() => arrayHelpers.form.setFieldValue(`${baseName}.filled`, false)}
        onBlur={() => arrayHelpers.form.setFieldValue(`${baseName}.filled`, true)}
        placeholder='Other...'
      />
    )
  }

  return (
    <Container>
      {custom && <RemoveCustom arrayHelpers={arrayHelpers} {...rest} />}
      <Label
        {...rest}
        htmlFor={name(baseName)}
      />
    </Container>
  )
}
